import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import { getLiftUser, clearLiftSession } from "../services/liftSession";
import { searchMaster } from "../services/liftApi";

// Réplica de amcmontacargas-L8.8 (PWAController::index / SearchController::form):
// búsqueda de guía master, primera pantalla después del login. Si la guía
// existe, el PHP original pasa a la vista de auditoría/medición (todavía no
// portada); si no, muestra el mismo error que search.blade.php.
function MontacargasHome() {
  const navigate = useNavigate();
  const user = getLiftUser();
  const [awb, setAwb] = useState("");
  const [searching, setSearching] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [master, setMaster] = useState(null);

  // Réplica de search.blade.php: solo dígitos, y a partir del 4° dígito se
  // inserta el guión (formato XXX-XXXXXXXX).
  const handleAwbChange = (event) => {
    const digits = event.target.value.replace(/\D/g, "").slice(0, 11);
    setAwb(digits.length > 3 ? `${digits.slice(0, 3)}-${digits.slice(3)}` : digits);
  };

  const handleLogout = () => {
    clearLiftSession();
    navigate("/montacargas", { replace: true });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setErrorMessage("");
    setMaster(null);
    setSearching(true);

    try {
      const response = await searchMaster({ awb });
      setMaster(response.data);
    } catch (error) {
      setErrorMessage(error.response?.data?.message || "No se pudo buscar la guía, intenta de nuevo.");
    } finally {
      setSearching(false);
    }
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2 className="h6 mb-0">Bienvenid@{user?.name ? `, ${user.name}` : ""}</h2>
        <button type="button" className="btn btn-outline-secondary btn-sm" onClick={handleLogout}>
          Cerrar sesión
        </button>
      </div>

      <div className="card mb-3">
        <div className="card-body">
          <h2 className="h6 card-title">Búsqueda master</h2>
          <form onSubmit={handleSubmit} noValidate>
            <div className="mb-3">
              <label className="form-label small" htmlFor="montacargas-awb">
                Ingresar guía master
              </label>
              <input
                id="montacargas-awb"
                type="text"
                inputMode="numeric"
                className="form-control"
                placeholder="000-00000000"
                value={awb}
                onChange={handleAwbChange}
                minLength={12}
                maxLength={12}
                disabled={searching}
                required
              />
            </div>

            {errorMessage && (
              <div className="alert alert-danger py-2 small mb-3" role="alert">
                {errorMessage}
              </div>
            )}

            <button type="submit" className="btn btn-primary" disabled={searching}>
              {searching ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2" />
                  Buscando...
                </>
              ) : (
                "Buscar"
              )}
            </button>
          </form>
        </div>
      </div>

      {master && (
        <div className="card">
          <div className="card-body">
            <h2 className="h6 card-title">{master.awb_master}</h2>
            <ul className="list-unstyled small mb-0">
              <li>Descripción: {master.description}</li>
              <li>Origen: {master.origin}</li>
              <li>Destino: {master.destiny}</li>
              <li>Piezas: {master.pieces}</li>
              <li>Peso: {master.weight}</li>
              <li>Volumen: {master.volume}</li>
              <li>Tipo de mercancía: {master.merchandise_type}</li>
              <li>Bultos validados: {master.packages}</li>
            </ul>
          </div>
        </div>
      )}
    </div>
  );
}

export default MontacargasHome;
